import { getPhotoName } from '../../../RentalPortalPhotoGallery.utils'

export function useRentalPortalPhotoGalleryTile({
  photo,
  onClick,
  onDelete,
  onRetry,
  onSetCover,
}) {
  function handleClick() {
    onClick(photo.id)
  }

  function handleDelete() {
    onDelete(photo.id)
  }

  function handleRetry() {
    onRetry(photo)
  }

  function handleSetCover() {
    onSetCover(photo.id)
  }

  const hasError = Boolean(photo.error)

  return {
    handleClick,
    handleDelete,
    handleRetry,
    handleSetCover,
    hasError,
    isUploading: Boolean(photo.uploading) && !hasError,
    photoName: getPhotoName(photo),
  }
}
